import { render, staticRenderFns } from "./PushFmsDialog.vue?vue&type=template&id=2bb4587f&scoped=true"
import script from "./PushFmsDialog.vue?vue&type=script&lang=js"
export * from "./PushFmsDialog.vue?vue&type=script&lang=js"
import style0 from "./PushFmsDialog.vue?vue&type=style&index=0&id=2bb4587f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4587f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb4587f')) {
      api.createRecord('2bb4587f', component.options)
    } else {
      api.reload('2bb4587f', component.options)
    }
    module.hot.accept("./PushFmsDialog.vue?vue&type=template&id=2bb4587f&scoped=true", function () {
      api.rerender('2bb4587f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/PushFmsDialog.vue"
export default component.exports